export default __webpack_public_path__ + "static/media/clip-list-is-empty.edb4760b.png";